import React from 'react'
import styles from './aboutSection.module.css'
import { useNavigate } from 'react-router-dom'

const AboutSection = () => {
    const navigate = useNavigate();
    return (
        <div className={styles.aboutContainer}>
            <div className={styles.aboutCol1}>
                <span>About Electrowiz</span>
            </div>
            <div className={styles.aboutCol2}>
                <p>
                    Electrowiz is a new-age sourcing platform built for manufacturers, EMS companies, and traders. From BOM uploads to urgent procurement, we simplify every step of the electronics sourcing journey—faster, smarter, and more organized.
                    <br />
                    <br />
                    We’re proudly made in Bangalore and built for India’s fast-moving industry.
                    <br />
                    <br />
                    Procurement made smart, so you can focus on building the future.
                </p>
                <button onClick={() => navigate("/aboutUs")} className={styles.knowMoreBtn}>Know More</button>
            </div>
        </div>
    )
}

export default AboutSection